import { render, staticRenderFns } from "./NeighbourhoodNav.vue?vue&type=template&id=660e5595&scoped=true&"
import script from "./NeighbourhoodNav.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodNav.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodNav.vue?vue&type=style&index=0&id=660e5595&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660e5595",
  null
  
)

export default component.exports